import { useMemo } from "react";
import {
  availableColor,
  borderAvailableColor,
  unAssignColor,
} from "../constants";

export const useDoorUIState = ({ status, clickBox, boxValue }) => {
  return useMemo(() => {
    const isAvailableDoors = status === "Doors";

    const baseColor = isAvailableDoors ? availableColor : unAssignColor;
    const baseBorderColor = isAvailableDoors
      ? borderAvailableColor
      : unAssignColor;

    const isSelected = Boolean(clickBox) && boxValue === status;

    return {
      isAvailableDoors,
      isSelected,
      color: isSelected ? "#ffffff" : baseColor,
      borderColor: isSelected ? baseColor : baseBorderColor,
      background: isSelected ? baseColor : "#ffffff",
      cursor: clickBox
        ? isSelected
          ? "default"
          : "pointer"
        : "default",
    };
  }, [status, clickBox, boxValue]);
};